<template>
  <div class="mx-auto w-full md:pt-20">
    <div class="text-center">
      <graphic-base height="117" width="117" viewBox="0 0 117 117">
        <alert-circle />
      </graphic-base>
    </div>
    <div class="mt-4">
      <p class="custom-color-neutral text-zt-lg text-center">{{ $t('message.LicensesSolicitudeComponent.modals.cancelRequest') }}</p>
    </div>
    <div class="mt-40 md:bottom-auto md:relative">
      <div class="w-full mx-auto">
        <zt-button outlined @click="$emit('cancel-request')" class="w-5/12 ml-2 button-shadow" data-vs-button="cancelRequest">
          {{ $t('message.LicensesSolicitudeComponent.modals.yes') }}
        </zt-button>
        <zt-button outlined @click="$emit('remove-warning')" class="w-5/12 float-right mr-2 button-shadow" data-vs-button="removeWarning">
          {{ $t('message.LicensesSolicitudeComponent.modals.no') }}
        </zt-button>
      </div>
    </div>
  </div>
</template>

<script>
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import alertCircle from '@/components/commons/Illustrations/graphicSVG/AlertCircleSVG'

export default {
  components: {
    graphicBase,
    alertCircle
  }
}
</script>